<template>
  <div v-if="$auth.user" class="mx-6 my-6 profile-section" data-cy="clientZoneDashboardRightRow">
    <div class="profile-section__partner-logo d-flex align-center">
      <v-img
        v-if="$auth.user.benefit?.active && partnerData?.logoUrl"
        max-height="30"
        max-width="132"
        class="mx-auto"
        contain
        :src="partnerData?.logoUrl"
        :title="partnerData?.name"
      />
    </div>
    <div class="profile_menu" data-cy="clientZoneDashboardProfileMenu">
      <ProfileMenu />
    </div>
    <ProfileData listen-to-click />
    <template v-if="!userDeactivated">
      <DashboardBox
        v-if="showInvitation"
        class="mt-4"
        dialog-name="invitation"
        icon="ticket"
        :title="$t('invitation.dashboard.title')"
        :text="$t('invitation.dashboard.text')"
        :button-text="$t('invitation.dashboard.buttonText')"
      />
      <DashboardBox
        v-if="showBenefits"
        class="mt-4"
        dialog-name="insurance-benefits"
        icon="payment"
        :title="$t('healthInsuranceProviderBenefits.dashboard.title')"
        :text="$t('healthInsuranceProviderBenefits.dashboard.text')"
        :button-text="$t('show')"
        data-cy-dashboard-box-button="clientZoneDashboardProfileSectionInsuranceProviderBenefitsButton"
        data-cy-dashboard-box="clientZoneDashboardProfileSectionInsuranceProviderBenefitsBox"
      />
      <DashboardBox
        v-if="showNewsletter"
        class="mt-4"
        dialog-name="newsletter-agreement"
        icon="mail-empty"
        :title="$t('newsletterAgreement.dashboard.title')"
        :text="$t('newsletterAgreement.dashboard.text')"
        :button-text="$t('show')"
      />
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import currentHealthInsuranceProvider from '@/feature/health-insurance-benefits/mixins/currentHealthInsuranceProvider';
import dashboardBoxes from '@/mixins/dashboardBoxes';
import invitation from '@/mixins/invitation';
import ProfileMenu from '@/components/Molecules/ProfileMenu';
import ProfileData from '@/components/Atoms/ProfileData';
import DashboardBox from '@/components/Atoms/DashboardBox';
import NeedHelpFab from '@/components/Molecules/NeedHelpFab.vue';

export default {
  name: 'ProfileSection',
  components: { NeedHelpFab, DashboardBox, ProfileData, ProfileMenu },
  mixins: [currentHealthInsuranceProvider, dashboardBoxes, invitation],
  computed: {
    ...mapGetters({
      userDeactivated: 'profile/dashboard/userDeactivated'
    })
  }
};
</script>

<style lang="scss" scoped>
.profile-section {
  position: relative;

  &__partner-logo {
    height: 48px;
  }

  .profile_menu {
    position: absolute;
    top: 0;
    right: 0;
  }

  &__partnered {
    position: absolute;
    right: 90.5px;
    bottom: -5px;
  }
}
</style>
